import { CompanyValidationSchema } from "@/components/pages/Settings/validation/companyValidationSchema";
import * as z from "zod";

const validationSchema = CompanyValidationSchema.pick({
  allowCollectiveInvoice: true,
  withoutTransport: true,
  membership: true,
  preferredTransportCompanyId: true,
});

export const LogisticsSettingsValidationSchema = validationSchema;
export type LogisticsSettingsFormInput = z.infer<typeof LogisticsSettingsValidationSchema>;
